export function parseModalSectionParam(
  value: string | number | boolean | null | undefined
): {
  isOpen: boolean;
  section: string | undefined;
} {
  if (value == null || value === "" || value === false) {
    return { isOpen: false, section: undefined };
  }

  const str = String(value);
  return {
    isOpen: true,
    section: str === "true" ? undefined : str.toLowerCase(),
  };
}
